<ng-template #endSlotContent>
  <ng-content select="[slot=end]"></ng-content>
</ng-template>

<!-- Only bit-form-control (the inline checkbox/radio/switch row) suppresses truncation, so its
  long labels wrap. Everywhere else — including bit-form-control-card — labels clip. -->
<span [ngClass]="{ 'tw-truncate': !isInsideFormControl }">
  <ng-content></ng-content>
  @if (isInsideFormControl) {
    <ng-container *ngTemplateOutlet="endSlotContent"></ng-container>
  }
</span>
@if (!isInsideFormControl) {
  <ng-container *ngTemplateOutlet="endSlotContent"></ng-container>
}
